$(document).on 'ready turbolinks:load', ->
  if $('#workplace_jobs_index').length > 0
    window.jobsPage = new JobsPage($('#workplace_jobs_index'))


class JobsPage
  constructor: (root) ->
    @root = root

  bindHideLinks: =>
    @root.find('.hide-job-btn').on 'ajax:success', (e) ->
      $(e.target).closest('.jobInput').fadeOut('slow')
      $('#showHiddenJobsWrapper').removeClass('d-none')

    $('.btn-translator').on 'click', (e) ->
      e.preventDefault()
      $(this).prev('#dynamic-translation-wrapper').find('.dynamic-translation-text').slideToggle 'fast', ->
        if $(this).is(':hidden')
          $(this).parent('#dynamic-translation-wrapper').next('.btn-translator').text I18n.t('dynamic_translation_button.' + $(this).attr('id'))

    # will be refactored in http://redmine.clickworker.intern/issues/23783
    $('.stories-slider').owlCarousel({
      loop: false,
      margin: 30,
      autoplay: false,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          nav: false,
          touchDrag: true,
          mouseDrag: true,
          dots: true
        },
        992: {
          items: 2,
          nav: true,
          mouseDrag: true,
          dots: true
        },
        1440: {
          items: 3,
          nav: true,
          mouseDrag: true,
          dots: true
        }
      }
    })
    $('.owl-carousel').each ->
      $(this).data('owl.carousel').onResize()

    # -------------------------------------------------------
          # Job list view toggler Grid/List
    # ------------------------------------------------------
    cwwJobListView = localStorage.getItem(gon.user + '_CWWJobList')
    if cwwJobListView == 'ListView'
      $('body[id*="workplace_jobs"]').addClass 'list-view'
      $('.jobInput').addClass 'list-view'
      if $('.shorties_wrp').length > 0
        $('.shorties_wrp').addClass 'shorties-list-view'
      $('.display-filter-grid').removeClass 'active'
      $('.display-filter-list').addClass 'active'
      $('.page-header').addClass 'list-view-header'

    $(document).on 'click', '.display-filter-list', ->
      $('body[id*="workplace_jobs"]').addClass 'list-view'
      $('.jobInput').addClass 'list-view'
      if $('.shorties_wrp').length > 0
        $('.shorties_wrp').addClass 'shorties-list-view'
      $('.page-header').addClass 'list-view-header'
      $('.display-filter-grid').removeClass 'active pointer-events-none'
      $('.display-filter-list').addClass 'active pointer-events-none'
      localStorage.setItem gon.user + '_CWWJobList', 'ListView'
      clickSectionPos = $(this).closest('ul').attr('data-bs-parent')
      $('html, body').animate scrollTop: $('#'+clickSectionPos).offset().top - 100, 150


    $(document).on 'click', '.display-filter-grid', ->
      $('body[id*="workplace_jobs"]').removeClass 'list-view'
      $('.jobInput').removeClass 'list-view'
      if $('.shorties_wrp').length > 0
        $('.shorties_wrp').removeClass 'shorties-list-view'
      $('.page-header').removeClass 'list-view-header'
      $('.display-filter-list').removeClass 'active pointer-events-none'
      $('.display-filter-grid').addClass 'active pointer-events-none'
      localStorage.setItem gon.user + '_CWWJobList', 'GridView'
      clickSectionPos = $(this).parent().parent().attr('data-bs-parent')
      $('html, body').animate scrollTop: $('#'+clickSectionPos).offset().top - 100, 100

    # -------------------------------------------------------
    # Job list view context menu
    # -------------------------------------------------------

    cardSelector = ".job-list-content-wrapper .card-deck .jobInput"

    # These selectors must be relative to an individual card.
    menuParentSelector = ".job-context-menu"
    menuSelectorToggle = "#{menuParentSelector} .dropdown-toggle"
    menuSelector = "#{menuParentSelector} .dropdown-menu"

    # Prevent duplicate document handlers after Turbolinks navigation.
    $(document).off ".jobList"


    closeContextMenus = =>
      menuParents = @root.find(menuParentSelector)
      toggles = menuParents.find(".dropdown-toggle")
      toggles.each ->
        instance = window.bootstrap?.Dropdown?.getInstance(this)
        instance?.hide()

      menus = @root.find(menuSelector)
      menus.removeClass "show"
      menus.removeAttr "style"

      menuParents.removeAttr "style"
      toggles.attr "aria-expanded", "false"


    showContextMenu = (e, targetElement, isRightClick = false) =>
      card = $(targetElement).closest(".jobInput")
      return unless card.length

      rect = card[0].getBoundingClientRect()

      x = Math.round(e.clientX - rect.left)
      if isRightClick
        y = Math.round(e.clientY - rect.top)
      else
        y = Math.round(e.clientY - rect.top - 20)

      closeContextMenus()

      menuParent = card.find(menuParentSelector).first()
      menu = menuParent.find(".dropdown-menu").first()

      return unless menuParent.length and menu.length

      menuParent.attr "style", "position: static;"

      toggle = menuParent.find(".dropdown-toggle")
      toggle.attr "aria-expanded", "true"

      menuStyle = """
        display: block;
        right: auto !important;
        left: #{x}px !important;
        top: #{y}px !important;
        transform: none !important;
        z-index: 1080 !important;
      """

      menu.addClass "show"
      menu.attr "style", menuStyle


    # Right-click
    $(document).on "contextmenu.jobList", cardSelector, (e) ->
      e.preventDefault()
      e.stopPropagation()

      return if $(e.currentTarget) == menuSelectorToggle
      showContextMenu e, e.currentTarget, true

      false


    # Two-finger touch
    $(document).on "touchstart.jobList", cardSelector, (e) ->
      originalEvent = e.originalEvent ? e
      touches = originalEvent.touches

      return unless touches? and touches.length is 2

      e.preventDefault()
      e.stopPropagation()

      touch1 = touches[0]
      touch2 = touches[1]

      midPoint =
        clientX: (touch1.clientX + touch2.clientX) / 2
        clientY: (touch1.clientY + touch2.clientY) / 2

      showContextMenu midPoint, e.currentTarget


    # Close when clicking outside the menu.
    $(document).on "click.jobList", (e) ->
      clickedInsideMenu = $(e.target).closest(menuParentSelector).length > 0
      return if clickedInsideMenu

      closeContextMenus()


    # Close with Escape.
    $(document).on "keydown.jobList", (e) ->
      closeContextMenus() if e.key is "Escape"
$(document).on 'ready turbolinks:load', ->
  if $('#workplace_jobs_index').length > 0
    window.jobsPage = new JobsPage($('#workplace_jobs_index'))


class JobsPage
  constructor: (root) ->
    @root = root

  bindHideLinks: =>
    @root.find('.hide-job-btn').on 'ajax:success', (e) ->
      $(e.target).closest('.jobInput').fadeOut('slow')
      $('#showHiddenJobsWrapper').removeClass('d-none')

    $('.btn-translator').on 'click', (e) ->
      e.preventDefault()
      $(this).prev('#dynamic-translation-wrapper').find('.dynamic-translation-text').slideToggle 'fast', ->
        if $(this).is(':hidden')
          $(this).parent('#dynamic-translation-wrapper').next('.btn-translator').text I18n.t('dynamic_translation_button.' + $(this).attr('id'))

    # will be refactored in http://redmine.clickworker.intern/issues/23783
    $('.stories-slider').owlCarousel({
      loop: false,
      margin: 30,
      autoplay: false,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          nav: false,
          touchDrag: true,
          mouseDrag: true,
          dots: true
        },
        992: {
          items: 2,
          nav: true,
          mouseDrag: true,
          dots: true
        },
        1440: {
          items: 3,
          nav: true,
          mouseDrag: true,
          dots: true
        }
      }
    })
    $('.owl-carousel').each ->
      $(this).data('owl.carousel').onResize()

    # -------------------------------------------------------
          # Job list view toggler Grid/List
    # ------------------------------------------------------
    cwwJobListView = localStorage.getItem(gon.user + '_CWWJobList')
    if cwwJobListView == 'ListView'
      $('body[id*="workplace_jobs"]').addClass 'list-view'
      $('.jobInput').addClass 'list-view'
      if $('.shorties_wrp').length > 0
        $('.shorties_wrp').addClass 'shorties-list-view'
      $('.display-filter-grid').removeClass 'active'
      $('.display-filter-list').addClass 'active'
      $('.page-header').addClass 'list-view-header'

    $(document).on 'click', '.display-filter-list', ->
      $('body[id*="workplace_jobs"]').addClass 'list-view'
      $('.jobInput').addClass 'list-view'
      if $('.shorties_wrp').length > 0
        $('.shorties_wrp').addClass 'shorties-list-view'
      $('.page-header').addClass 'list-view-header'
      $('.display-filter-grid').removeClass 'active pointer-events-none'
      $('.display-filter-list').addClass 'active pointer-events-none'
      localStorage.setItem gon.user + '_CWWJobList', 'ListView'
      clickSectionPos = $(this).closest('ul').attr('data-bs-parent')
      $('html, body').animate scrollTop: $('#'+clickSectionPos).offset().top - 100, 150


    $(document).on 'click', '.display-filter-grid', ->
      $('body[id*="workplace_jobs"]').removeClass 'list-view'
      $('.jobInput').removeClass 'list-view'
      if $('.shorties_wrp').length > 0
        $('.shorties_wrp').removeClass 'shorties-list-view'
      $('.page-header').removeClass 'list-view-header'
      $('.display-filter-list').removeClass 'active pointer-events-none'
      $('.display-filter-grid').addClass 'active pointer-events-none'
      localStorage.setItem gon.user + '_CWWJobList', 'GridView'
      clickSectionPos = $(this).parent().parent().attr('data-bs-parent')
      $('html, body').animate scrollTop: $('#'+clickSectionPos).offset().top - 100, 100

    # -------------------------------------------------------
    # Job list view context menu
    # -------------------------------------------------------

    cardSelector = ".job-list-content-wrapper .card-deck .jobInput"

    # These selectors must be relative to an individual card.
    menuParentSelector = ".job-context-menu"
    menuSelectorToggle = "#{menuParentSelector} .dropdown-toggle"
    menuSelector = "#{menuParentSelector} .dropdown-menu"

    # Prevent duplicate document handlers after Turbolinks navigation.
    $(document).off ".jobList"


    closeContextMenus = =>
      menuParents = @root.find(menuParentSelector)
      toggles = menuParents.find(".dropdown-toggle")
      toggles.each ->
        instance = window.bootstrap?.Dropdown?.getInstance(this)
        instance?.hide()

      menus = @root.find(menuSelector)
      menus.removeClass "show"
      menus.removeAttr "style"

      menuParents.removeAttr "style"
      toggles.attr "aria-expanded", "false"


    showContextMenu = (e, targetElement, isRightClick = false) =>
      card = $(targetElement).closest(".jobInput")
      return unless card.length

      rect = card[0].getBoundingClientRect()

      x = Math.round(e.clientX - rect.left)
      if isRightClick
        y = Math.round(e.clientY - rect.top)
      else
        y = Math.round(e.clientY - rect.top - 20)

      closeContextMenus()

      menuParent = card.find(menuParentSelector).first()
      menu = menuParent.find(".dropdown-menu").first()

      return unless menuParent.length and menu.length

      menuParent.attr "style", "position: static;"

      toggle = menuParent.find(".dropdown-toggle")
      toggle.attr "aria-expanded", "true"

      menuStyle = """
        display: block;
        right: auto !important;
        left: #{x}px !important;
        top: #{y}px !important;
        transform: none !important;
        z-index: 1080 !important;
      """

      menu.addClass "show"
      menu.attr "style", menuStyle


    # Right-click
    $(document).on "contextmenu.jobList", cardSelector, (e) ->
      e.preventDefault()
      e.stopPropagation()

      return if $(e.currentTarget) == menuSelectorToggle
      showContextMenu e, e.currentTarget, true

      false


    # Two-finger touch
    $(document).on "touchstart.jobList", cardSelector, (e) ->
      originalEvent = e.originalEvent ? e
      touches = originalEvent.touches

      return unless touches? and touches.length is 2

      e.preventDefault()
      e.stopPropagation()

      touch1 = touches[0]
      touch2 = touches[1]

      midPoint =
        clientX: (touch1.clientX + touch2.clientX) / 2
        clientY: (touch1.clientY + touch2.clientY) / 2

      showContextMenu midPoint, e.currentTarget


    # Close when clicking outside the menu.
    $(document).on "click.jobList", (e) ->
      clickedInsideMenu = $(e.target).closest(menuParentSelector).length > 0
      return if clickedInsideMenu

      closeContextMenus()


    # Close with Escape.
    $(document).on "keydown.jobList", (e) ->
      closeContextMenus() if e.key is "Escape"
